import { createApi } from '@reduxjs/toolkit/query/react';
import { GuidT, SelectIF } from '@/types/common';
import { CategoryIF, PropertyBaseIF } from '@/api/propertyApi/types';
import { fetchRestApiQuery } from '@/helpers/api';
import {
    transformCategoriesToSelect,
    transformToSelect,
} from '@/helpers/normaliseProperties';

export const propertyApi = createApi({
    reducerPath: 'propertyApi',
    baseQuery: fetchRestApiQuery('/'),
    endpoints: (builder) => ({
        getCategoriesSelectProperties: builder.query<
            SelectIF<GuidT>[] | null,
            void
        >({
            query: () => ({
                url: `/Categories`,
            }),
            transformResponse(response: { data?: CategoryIF[] }) {
                return transformCategoriesToSelect(response?.data);
            },
        }),
        getColorsSelectProperties: builder.query<
            SelectIF<GuidT>[] | null,
            void
        >({
            query: () => ({
                url: `/Colors`,
            }),
            transformResponse(response: { data?: PropertyBaseIF[] }) {
                return transformToSelect(response?.data);
            },
        }),
        getBrandsSelectProperties: builder.query<
            SelectIF<GuidT>[] | null,
            void
        >({
            query: () => ({
                url: `/Brands`,
            }),
            transformResponse(response: { data?: PropertyBaseIF[] }) {
                return transformToSelect(response?.data);
            },
        }),
        getMaterialsSelectProperties: builder.query<
            SelectIF<GuidT>[] | null,
            void
        >({
            query: () => ({
                url: `/Materials`,
            }),
            transformResponse(response: { data?: PropertyBaseIF[] }) {
                return transformToSelect(response?.data);
            },
        }),
    }),
});
